import React from 'react';
import '../../assets/styles/components/dot-spinner.scss'; // Import any CSS file related to styling the DotSpinner if needed

const DotSpinner: React.FC = () => {
  return (
    <div className="dot-spinner">
      <div className="dot dot-1"></div>
      <div className="dot dot-2"></div>
      <div className="dot dot-3"></div>
      <div className="dot dot-4"></div>
      <div className="dot dot-5"></div>
      <div className="dot dot-6"></div>
      <div className="dot dot-7"></div>
      <div className="dot dot-8"></div>
    </div>
  );
};

export default DotSpinner;
